app.directive('tabSet', ["PackeryService", "$timeout", function(PackeryService, $timeout) {
	return {
		restrict: 'AE',
		templateUrl: 'tab-set.html',
		transclude: true,
		scope: {},
		replace: true,
		controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
			$scope.tabs = [];
			this.addTab = function(childScope) {
				if(typeof($scope.currentTab) == 'undefined') {
					$scope.currentTab = childScope.title;
					childScope.active = true;
				}
				if($attrs.defaultTab !== '' && childScope.url == $attrs.defaultTab) {
					$scope.setActive(childScope);
				}
				$scope.tabs.push(childScope);
			};

			$scope.setActive = function(tab) {
				for(var i = 0; i < $scope.tabs.length; i++) {
					$scope.tabs[i].active = false;
				}
				tab.active = true;

				// Relayout Packerylle, jos sellainen tabista löytyy. Näin se osaa laskea tarvitsemansa leveyden ja toimii oikein.
				if($(tab.element).find('[packery]').length > 0 && window['isIE']) {
					$timeout(function() {
						for(var i = 0; i < $(tab.element).find('[packery]').length; i++) {
							Packery.data($(tab.element).find('[packery]')[i]).layout();
						}
					}, 300);
				}

				// Refresh Slickille, jos sellainen tabista löytyy. Näin se osaa laskea tarvitsemansa leveyden ja toimii oikein.
				if($(tab.element).find('slick').length > 0) {
					$timeout(function() {
						for(var i = 0; i < $(tab.element).find('slick').length; i++) {
							$($(tab.element).find('slick')[i]).slick('setPosition');
						}
					});
				}
			};

			this.checkActive = function(tab) {
				var index = $scope.tabs.indexOf(tab);
				for(var i = index -1; i >= 0; i--) {
					if($scope.tabs[i].active == 'true') {
						return false;
					}
				}
				$scope.setActive(tab);
			};
		}]
	};
}]);